export const cardsData = [
  {
    id: 1,
    title: '今日顶流对决：谁才是2026年暑期档真正的收视王者',
    tag: '明星PK',
    summary: '暑期档过半，两部S+古装剧正面交锋。数据脱水后的真实热度对比，看看谁才是观众心中的第一选择。',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20cinematic%20scene%20with%20two%20ancient%20Chinese%20costume%20drama%20characters%20facing%20each%20other%20in%20a%20versus%20style%20composition%2C%20warm%20golden%20lighting%2C%20theatrical%20atmosphere%2C%20minimalist%20cream%20background%20with%20subtle%20gradient%2C%20clean%20editorial%20style&width=800&height=500&seq=card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '综艺名场面投票：本季最出圈片段你投给谁',
    tag: '话题对决',
    summary: '各大综艺纷纷祭出名场面，有些让人捧腹，有些让人泪目。这波你站哪边？投票通道已开启。',
    image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20variety%20show%20stage%20scene%20with%20colorful%20lights%20and%20dramatic%20spotlight%2C%20warm%20tones%2C%20energetic%20atmosphere%2C%20minimalist%20cream%20background%2C%20editorial%20photography%20style&width=800&height=500&seq=card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '吃瓜速递：这对CP到底是真的还是营业',
    tag: '八卦PK',
    summary: '同款穿搭、深夜互动、剧组路透……线索越扒越多，网友分成两派吵翻了天。你站哪边？',
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20romantic%20silhouette%20of%20two%20people%20standing%20close%20under%20warm%20city%20night%20lights%2C%20soft%20bokeh%20background%2C%20dreamy%20atmosphere%2C%20minimalist%20elegant%20composition%2C%20editorial%20style&width=800&height=500&seq=card-03&orientation=landscape',
  },
  {
    id: 4,
    title: 'OST对决：古风vs电子，哪首歌才是今年BGM之王',
    tag: '每日投票',
    summary: '上半年影视OST神仙打架，古风弦乐与电子混音正面硬刚。戴上耳机，投出你的一票。',
    image: 'https://readdy.ai/api/search-image?query=A%20musical%20competition%20theme%20with%20traditional%20Chinese%20instruments%20on%20one%20side%20and%20modern%20electronic%20music%20equipment%20on%20the%20other%2C%20warm%20golden%20and%20cool%20silver%20split%20lighting%2C%20minimal%20cream%20background&width=800&height=500&seq=card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '演技大赏：90后小生小花谁才是实力派',
    tag: '明星PK',
    summary: '流量退潮后，演技成为硬通货。盘点近期高光表演，谁的表现让你眼前一亮？',
    image: 'https://readdy.ai/api/search-image?query=A%20theatrical%20spotlight%20on%20an%20empty%20stage%20with%20a%20single%20microphone%20stand%2C%20dramatic%20warm%20lighting%20creating%20contrast%2C%20elegant%20minimalist%20composition%2C%20editorial%20style%20with%20cream%20background&width=800&height=500&seq=card-05&orientation=landscape',
  },
  {
    id: 6,
    title: '解散还是重组：团粉和唯粉的终极对决',
    tag: '热门对决',
    summary: '成团五年，合约到期的关键时刻。团粉呼吁续约，唯粉各怀心思。这次投票可能影响最终走向。',
    image: 'https://readdy.ai/api/search-image?query=A%20group%20of%20performers%20standing%20together%20on%20a%20stage%20with%20dramatic%20backlighting%2C%20atmospheric%20fog%2C%20warm%20tones%2C%20minimalist%20cream%20background%2C%20editorial%20photography&width=800&height=500&seq=card-06&orientation=landscape',
  },
];

export const appData = {
  title: '每日大赛APP — 吃瓜投票随时随地',
  description: '下载每日大赛官方APP，第一时间接收热门PK推送，参与实时投票，与千万吃瓜群众一起围观每场话题对决。支持iOS和Android双平台。',
  features: ['实时PK推送通知', '去水真实投票数据', '独家八卦深度解读', '话题讨论互动社区'],
  image: 'https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20mockup%20displaying%20a%20voting%20app%20interface%20with%20two%20options%20in%20a%20versus%20layout%2C%20warm%20coral%20and%20cream%20color%20scheme%2C%20clean%20UI%20design%2C%20minimalist%20presentation%2C%20editorial%20product%20photography&width=600&height=700&seq=app-section&orientation=portrait',
};

export const indexData = [
  { id: 1, title: '暑期档收视率PK', tag: '影视对决', count: '128.6万票', hot: true },
  { id: 2, title: '综艺名场面投票', tag: '综艺PK', count: '96.3万票', hot: true },
  { id: 3, title: 'OST年度金曲', tag: '音乐对决', count: '87.1万票', hot: true },
  { id: 4, title: '古装男神PK', tag: '颜值对决', count: '215.4万票', hot: true },
  { id: 5, title: '演技实力大赏', tag: '演技PK', count: '73.8万票', hot: false },
  { id: 6, title: '年度CP盘点', tag: 'CP对决', count: '189.2万票', hot: true },
  { id: 7, title: '团魂vs个人发展', tag: '饭圈PK', count: '54.6万票', hot: false },
  { id: 8, title: '新生代演技派', tag: '新星对决', count: '41.9万票', hot: false },
  { id: 9, title: '综艺笑点王', tag: '搞笑PK', count: '102.7万票', hot: true },
];

export const carouselData = [
  {
    id: 1,
    title: '暑期档终极对决：古装双王正面碰撞',
    tag: '焦点专题',
    category: '影视PK',
    description: '两部S+古装剧同日上线，从收视率到口碑全面交锋。制作班底、主演阵容、剧情节奏全方位对比，谁才是这个夏天真正的爆款？参与投票说出你的选择。',
    stats: '参与投票：286.5万人',
    image: 'https://readdy.ai/api/search-image?query=Two%20ancient%20Chinese%20warriors%20facing%20each%20other%20in%20dramatic%20composition%2C%20one%20in%20gold%20armor%20one%20in%20silver%20armor%2C%20cinematic%20lighting%20with%20warm%20tones%2C%20minimalist%20cream%20background%2C%20epic%20versus%20atmosphere&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '热搜制造机：谁是上半年话题度之王',
    tag: '焦点专题',
    category: '话题对决',
    description: '盘点2026上半年登上热搜次数最多的明星与事件，从作品到八卦，从官宣到翻车，数据不会说谎。看看谁是真正的流量核心。',
    stats: '参与投票：198.3万人',
    image: 'https://readdy.ai/api/search-image?query=A%20trending%20chart%20visual%20metaphor%20with%20rising%20bars%20and%20sparkles%2C%20warm%20golden%20and%20coral%20tones%2C%20dynamic%20energy%2C%20minimalist%20cream%20background%2C%20editorial%20infographic%20style&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '老剧新看：经典IP翻拍到底是毁还是神',
    tag: '焦点专题',
    category: '情怀PK',
    description: '一波经典IP翻拍潮来袭，有的口碑逆袭，有的惨遭群嘲。老粉和新观众的审美差异，让这场PK格外精彩。你心中哪部翻拍最成功？',
    stats: '参与投票：152.7万人',
    image: 'https://readdy.ai/api/search-image?query=A%20split%20composition%20showing%20classic%20film%20aesthetic%20on%20left%20and%20modern%20cinematic%20style%20on%20right%2C%20warm%20vintage%20tones%20transforming%20to%20contemporary%20colors%2C%20minimalist%20cream%20background%2C%20editorial%20style&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '跨界破圈：偶像转型演员谁真正成功了',
    tag: '焦点专题',
    category: '转型PK',
    description: '从舞台到片场，从爱豆到演员。有人凭实力获得认可，有人始终摆脱不了标签。盘点近年跨界最成功的几位，谁的转型之路最值得鼓掌？',
    stats: '参与投票：167.9万人',
    image: 'https://readdy.ai/api/search-image?query=A%20spotlight%20on%20a%20stage%20transforming%20into%20a%20film%20set%2C%20symbolic%20transition%20from%20music%20to%20acting%2C%20warm%20dramatic%20lighting%2C%20minimalist%20cream%20background%2C%20cinematic%20editorial%20style&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
];

export const faqData = [
  {
    id: 1,
    question: '每日大赛的投票结果是否真实可信？',
    answer: '每日大赛采用多重去水机制，包括设备指纹验证、投票行为分析和人工审核，确保每一票都来自真实用户。我们坚持"去水靠真热度"的原则，所有公开的投票数据均经过脱水和反作弊处理，让你看到的每一组数据都经得起推敲。',
  },
  {
    id: 2,
    question: '如何参与每日娱乐PK投票？',
    answer: '你可以通过每日大赛官网或APP参与投票。每个PK话题在有效期内每人可投一票，部分热门对决会开放每日限时加票机会。投票无需注册，但登录后可解锁更多功能如评论互动和历史记录查看。',
  },
  {
    id: 3,
    question: 'PK话题是如何产生的？',
    answer: 'PK话题由编辑团队根据实时娱乐热点、网友讨论热度和平台数据综合筛选产生，同时也接受用户投稿建议。我们力求覆盖影视、综艺、音乐、八卦等多个维度，让每位吃瓜群众都能找到感兴趣的对决。',
  },
  {
    id: 4,
    question: '投票结果会影响实际的娱乐行业吗？',
    answer: '每日大赛的投票数据作为重要的受众反馈参考，已被多家娱乐媒体和制作方关注。虽然投票结果不直接决定行业决策，但高参与度的PK话题往往能反映真实的观众偏好和市场风向，是行业观察的重要晴雨表。',
  },
];

export const commentsData = [
  {
    id: 1,
    nickname: '吃瓜第一线',
    time: '2小时前',
    content: '这个暑期档对决太刺激了！两边都追了，但客观说A剧的制作确实更精良，B剧的剧本更扎实。投完票发现我和大多数人想的一样哈哈哈。',
    likes: 2836,
  },
  {
    id: 2,
    nickname: '娱乐显微镜',
    time: '5小时前',
    content: 'OST对决这个真的难选，古风和电子我都爱。不过今年古风确实神仙打架，光《月落长安》那一首就够我循环一个月了。已投古风阵营！',
    likes: 1942,
  },
  {
    id: 3,
    nickname: '不八卦会死星人',
    time: '8小时前',
    content: 'CP那个投票我纠结了三天，这对真的太真了！同款帽子、同款咖啡店、同款定位，这不是巧合我直播倒立。坚定站"是真的"阵营！',
    likes: 3517,
  },
];

export const rankingData = [
  { rank: 1, title: '古装男神终极PK：谁是颜值天花板', tag: '颜值对决', votes: '328.6万', trend: 'up', change: '+12%' },
  { rank: 2, title: '暑期古装双王正面交锋', tag: '影视对决', votes: '286.5万', trend: 'up', change: '+8%' },
  { rank: 3, title: '真假CP大揭秘：你站哪边', tag: 'CP对决', votes: '241.3万', trend: 'up', change: '+23%' },
  { rank: 4, title: '上半年热搜话题度之王', tag: '话题对决', votes: '198.3万', trend: 'down', change: '-3%' },
  { rank: 5, title: 'OST年度金曲对决', tag: '音乐PK', votes: '175.2万', trend: 'up', change: '+15%' },
  { rank: 6, title: '综艺名场面票选', tag: '综艺PK', votes: '152.7万', trend: 'up', change: '+6%' },
];

export const aboutData = {
  title: '关于每日大赛',
  description: '每日大赛是国内领先的娱乐PK投票平台，聚焦影视、综艺、音乐、八卦等泛娱乐领域，每天推出新鲜有趣的话题对决，让千万吃瓜群众用投票表达态度。我们坚持数据透明、去水真实，致力于打造最纯粹的娱乐互动社区。在这里，每一票都有分量，每一次围观都有参与感。',
  stats: [
    { label: '日均活跃用户', value: '580万+' },
    { label: '累计PK话题', value: '1.2万+' },
    { label: '总投票人次', value: '8.6亿+' },
    { label: '覆盖娱乐领域', value: '12个' },
  ],
};

export const updatesData = [
  { id: 1, date: '2026.07.30', title: '【新PK上线】暑期档终极对决投票通道今日开启', tag: '新话题' },
  { id: 2, date: '2026.07.29', title: '【数据公告】古装男神PK投票突破300万，创历史新高', tag: '里程碑' },
  { id: 3, date: '2026.07.28', title: '【功能更新】APP V3.2上线，新增PK实时数据看板', tag: '更新' },
  { id: 4, date: '2026.07.27', title: '【结果公布】上半年最受欢迎综艺票选结果出炉', tag: '结果' },
  { id: 5, date: '2026.07.26', title: '【用户投稿】你提的PK话题被选中啦！来看看有没有你的', tag: '互动' },
  { id: 6, date: '2026.07.25', title: '【特别企划】七夕CP投票专场预告，准备好你的CP了吗', tag: '预告' },
  { id: 7, date: '2026.07.24', title: '【反作弊升级】新增五重去水机制，投票数据更真实', tag: '公告' },
];

export const featuresData = [
  {
    id: 1,
    icon: 'ri-scales-3-line',
    title: '去水真热度',
    description: '多重反作弊机制，每票实名验证，杜绝刷票水军，让你看到的数据就是真实的民意。',
  },
  {
    id: 2,
    icon: 'ri-fire-line',
    title: '每日新话题',
    description: '紧跟娱乐热点，每天更新PK话题。影视、综艺、音乐、八卦，你想看的这里都有。',
  },
  {
    id: 3,
    icon: 'ri-bar-chart-grouped-line',
    title: '数据可视化',
    description: '投票结果实时更新，趋势曲线一目了然，地域分布、年龄构成全方位展示PK数据。',
  },
  {
    id: 4,
    icon: 'ri-chat-smile-2-line',
    title: '吃瓜互动社区',
    description: '投票只是开始，评论区才是灵魂。与千万吃瓜群众一起讨论、吐槽、分享观点。',
  },
];

export const mediaData = [
  {
    id: 1,
    title: '【深度解读】2026上半年娱乐PK数据报告',
    source: '每日大赛数据团队',
    description: '用数据说话，透视上半年最热话题、最高参与度PK和最具争议对决背后的娱乐消费趋势。',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20data%20report%20visual%20with%20charts%20and%20graphs%20in%20warm%20coral%20and%20cream%20tones%2C%20minimalist%20infographic%20style%2C%20clean%20editorial%20composition%2C%20soft%20lighting&width=800&height=450&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '【幕后故事】一条PK话题是如何诞生的',
    source: '编辑团队',
    description: '从热点监测到选题讨论，从数据预判到上线运营，带你走进每日大赛PK话题的诞生全过程。',
    image: 'https://readdy.ai/api/search-image?query=A%20creative%20team%20brainstorming%20around%20a%20table%20with%20sticky%20notes%20and%20idea%20boards%2C%20warm%20natural%20lighting%2C%20collaborative%20atmosphere%2C%20minimalist%20cream%20background%2C%20editorial%20style&width=800&height=450&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '【行业观察】投票经济：用户为什么爱PK',
    source: '行业研究',
    description: '从心理学和行为经济学角度，分析娱乐PK投票为何能持续吸引大量用户深度参与的内在逻辑。',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20concept%20of%20human%20decision%20making%20with%20two%20diverging%20paths%2C%20warm%20golden%20and%20coral%20tones%2C%20minimalist%20geometric%20composition%2C%20editorial%20illustration%20style&width=800&height=450&seq=media-03&orientation=landscape',
  },
];

export const contactData = {
  title: '联系我们',
  description: '有好的PK话题建议？想与我们合作？或者发现了有趣的娱乐八卦线索？欢迎随时联系我们。商务合作、内容投稿、意见建议都欢迎。',
  email: 'hello@meiridasai.com',
  wechat: '每日大赛小助手',
  tips: '工作时间：周一至周日 10:00-22:00，吃瓜不打烊！',
};

export const topicsData = [
  { id: 1, name: '古装男神', heat: '328万', color: 'bg-primary-500' },
  { id: 2, name: '暑期档PK', heat: '286万', color: 'bg-accent-500' },
  { id: 3, name: 'CP真假', heat: '241万', color: 'bg-primary-400' },
  { id: 4, name: 'OST对决', heat: '175万', color: 'bg-accent-400' },
  { id: 5, name: '演技实力', heat: '152万', color: 'bg-primary-300' },
  { id: 6, name: '综艺名场面', heat: '138万', color: 'bg-accent-300' },
  { id: 7, name: '偶像转型', heat: '127万', color: 'bg-primary-500' },
  { id: 8, name: '翻拍经典', heat: '113万', color: 'bg-accent-500' },
  { id: 9, name: '新生代演员', heat: '98万', color: 'bg-primary-400' },
];

export const navLinks = [
  { label: '首页', href: '#hero' },
  { label: 'APP下载', href: '#app' },
  { label: '吃瓜评论', href: '#comments' },
  { label: '关于我们', href: '#about' },
  { label: '平台特色', href: '#features' },
  { label: '热门榜单', href: '#ranking' },
];